
import HotelsCarousel from '@/components/HotelsCarousel.vue'

export default {
  components: { HotelsCarousel },
  props: {
    item: { type: Object, required: true },
    selected: { type: Boolean, default: false }
  },
  data () {
    return {
      moreOpen: false
    }
  },
  computed: {
    hotelImages () {
      const images = this.item.images
      if (Array.isArray(images) && images.length) return images
      return this.item.image ? [this.item.image] : []
    },
    starRating () {
      const s = parseInt(this.item.starRating, 10)
      return s > 0 && s <= 5 ? s : 0
    },
    guestRating () {
      const g = parseFloat(this.item.guestRating)
      return !isNaN(g) && g > 0 ? g.toFixed(1) : null
    },
    reviewLabel () {
      const g = parseFloat(this.item.guestRating)
      if (g >= 9) return this.$t('hotels.results.reviewWonderful') || 'Wonderful'
      if (g >= 8) return this.$t('hotels.results.reviewVeryGood') || 'Very Good'
      if (g >= 7) return this.$t('hotels.results.reviewGood') || 'Good'
      if (g >= 6) return this.$t('hotels.results.reviewOkay') || 'Okay'
      return this.$t('hotels.results.reviewFair') || 'Fair'
    },
    nights () {
      return Math.max(1, this.$store.state.hotelStayNights || 1)
    },
    useLocal () {
      return this.$store.state.localCurrency
    },
    displaySymbol () {
      return this.useLocal
        ? (this.item.currencySymbolLocal || '$')
        : (this.item.currencySymbol || '$')
    },
    priceLabel () {
      return this.$store.state.hotelPriceDisplayMode === 'nightly' ? this.$t('hotels.results.night') : this.$t('hotels.results.stay')
    },
    minPriceFormatted () {
      const raw = this.useLocal ? this.item.minPriceLocal : this.item.minPrice
      const price = this.$store.state.hotelPriceDisplayMode === 'nightly'
        ? raw / this.nights
        : raw
      return Math.ceil(price).toLocaleString()
    },
    firstRoom () {
      return (this.item.rooms && this.item.rooms[0]) || null
    },
    providerName () {
      return this.firstRoom ? (this.firstRoom.provider || this.firstRoom.name) : null
    },
    providerLogo () {
      return this.firstRoom ? this.firstRoom.providerLogo : null
    },
    otherRooms () {
      if (!this.item.rooms || this.item.rooms.length <= 1) return []
      return this.item.rooms.slice(1, 5)
    }
  },
  methods: {
    openDeal () {
      if (this.firstRoom && this.firstRoom.partnerDeeplinkUrl) {
        window.open(this.firstRoom.partnerDeeplinkUrl, '_blank')
      }
    },
    formatPrice (room) {
      const raw = this.useLocal ? (room.priceLocal || room.minPriceLocal || room.minPrice) : room.minPrice
      const price = this.$store.state.hotelPriceDisplayMode === 'nightly'
        ? raw / this.nights
        : raw
      return Math.ceil(price).toLocaleString()
    }
  }
}
